const translations = {
    translation: {
        views: {
            applications: {
                recording_service: {
                    title: 'Recording Service',
                    short_title: 'RS',
                    application_list: {
                        description:
                            'ログ除外リストが最初に適用され、次にログ対象リストが適用されます。どちらかのリストのみ登録されている場合、そのリストのみ適用されます。',
                        dialog: {
                            hint: '完全なファイルパスまたは正規表現を指定してください。',
                            example: '例： {{example}}'
                        }
                    },
                    redaction_list: {
                        import_from_template:
                            'テンプレートからフィールド編集設定をインポート'
                    }
                }
            }
        },
        general: {
            Add: '追加',
            Added: '作成日時',
            Back: '戻る',
            Close: '閉じる',
            Cancel: 'キャンセル',
            Delete: '削除',
            Field: 'フィールド',
            Item: 'アイテム',
            Ok: 'OK',
            Recorders: 'レコーダー',
            Logo: 'ロゴ',
            Logs: 'ログ',
            Error: 'エラー',
            Templates: 'テンプレート',
            Loading: '読み込み中...',
            Select: '選択',
            Start: '開始',
            Stop: '停止',
            Name: '名前',
            Host: 'ホスト',
            Tag: 'タグ',
            Template: 'テンプレート',
            Status: '状態',
            Save: '保存',
            Saved: '保存しました',
            Computer: 'コンピュータ',
            Log: 'ログ',
            Username: 'ユーザー名',
            Password: 'パスワード',
            NotFound: '見つかりませんでした',
            Remove: '削除',
            Filter: 'フィルタ',
            Cached: 'キャッシュ済み',
            Id: 'ID',
            Role: 'ロール',
            Open: '開く',
            Dismiss: '閉じる',
            Acknowledge: '同意する',
            Next: '次へ',
            Prev: '前へ',
            Screenshot: 'スクリーンショット',
            Settings: '設定',
            Submit: '送信',
            Yesterday: '昨日',
            Time: '時間',
            Date: '日付',
            Yes: 'はい',
            Min: '最小',
            Max: '最大',
            new_template: '新しいテンプレート',
            Create: '作成',
            clear_all: '全てクリア',
            Transformations: '変換モデル',
            transformation_pattern: '正規表現',
            transformation_replacement: '置換',
            transformation_case_insensitive: '大文字小文字を区別しない',
            About: 'バージョン情報',
            Authors: '作成者',
            Version: 'バージョン',
            ImageProcessingVersion: '画像処理バージョン',
            Edit: '編集',
            In_progress: '進行中',
            Application: 'アプリケーション',
            Element_type: '要素のタイプ',
            Timestamp: 'タイムスタンプ',
            uploading: 'アップロード中',
            from: '起点',
            to: '終点',
            user_name: 'ユーザー名',
            connect_to_timeline: 'Timelineアカウントに接続する',
            connect: '接続',
            revoke_access: 'アクセスの取り消し',
            not_logged_in:
                'Timelineへログをアップロードするため、Recording Serviceがあなたの許可を求めています',
            not_connected_to_timeline:
                'アップロード権限がありません。Timelineに接続して権限を与えてください。',
            connected_to_timeline: '{{ email }}として接続しました',
            General: '全般',
            Export: 'エクスポート',
            Agents: 'エージェント',
            Compatible: '互換'
        },
        error: {
            could_not_remove_recorders:
                '次のレコーダーを削除できませんでした：{{ list }}',
            could_not_save_template:
                '次のテンプレートの保存中にエラーが発生しました： "{{templateName}}"後ほど改めてお試しください',
            could_not_delete_template:
                '次のテンプレートを削除できませんでした："{{templateName}}"後ほど改めてお試しください',
            internal_server_error: {
                large_text: '内部サーバーエラー',
                small_text:
                    'メンテナンスのためサーバーがダウンしているようです。しばらくしてからもう一度お試しください。'
            },
            forbidden_error: {
                large_text: 'アクセスが禁止されています',
                small_text: 'このページを表示する権限がないようです'
            },
            general_error: {
                large_text: 'リクエストがステータスコードで失敗しました'
            },
            not_found_error: {
                large_text: '要求されたリソースが見つかりませんでした'
            },
            could_not_save_timeline_connection: {
                UnknownError:
                    'Timeline 接続情報の保存中にエラーが発生しました。後ほど改めてお試しください',
                BadUrl:
                    '指定したURLは正しくありません。有効なURLに訂正して、再試行ください',
                ServerUnreachable:
                    'サーバーにアクセスできません。管理者に通知して、後ほど改めてお試しください。',
                ServerError:
                    'サーバーに問題があります。管理者に通知して、後ほど改めてお試しください。',
                SslError:
                    'SSL証明書に問題があります。管理者に通知して、後ほど改めてお試しください。'
            },
            invalid_value: '値が無効です。',
            could_not_upload_timeline: {
                too_large_request:
                    'ログの中に一意のイベントが多すぎるため、Timeline へのアップロードに失敗しました。この問題を解決するには、アップロードするログの数を減らしてください。根本原因を解決するには、タイムラインにログインして、プロジェクトから全データ削除の必要があるかもしれません。'
            },
            RegexParseException:
                '変換モデルの保存中にエラーが発生しました。有効なパターンで再試行してください。',
            RegexTimeoutException:
                'このパターンの処理は時間がかかりすぎます。別のものでもう一度やり直してください。',
            UnknownException:
                '変換モデルの保存中にエラーが発生しました。有効なパターンで再試行してください。',
            upload_not_cancellable: 'アップロードはキャンセルできません',
            transformation_not_cancellable: '変換はキャンセルできません',
            deletion_not_cancellable: '削除はキャンセルできません',
            something_happened:
                '問題が発生しました。後ほど改めてお試しください。',
            invalid_base_url:
                'Recording ServiceのパブリックURLが正しくありません。有効なURLに訂正して、再試行ください',
            from_to_same: '「起点」と「終点」の値を同じにすることはできません'
        },
        status_codes: {
            '503': {
                message: 'サービスは利用できません',
                detailed_message:
                    '現在、サーバーはリクエストを処理できません。後ほど改めてお試しください'
            },
            '500': {
                message: '内部サーバーエラー',
                detailed_message:
                    'サーバーに問題があります。管理者に通知して、後ほど改めてお試しください。'
            },
            '409': {
                message: '競合',
                detailed_message:
                    'サーバー認証が失敗しました。要求は、リソースの現状状態との競合により完了することができませんでした。'
            },
            '403': {
                message: '閲覧禁止されています',
                detailed_message: '十分な権限がありません'
            },
            '404': {
                message: '未検出',
                detailed_message: 'リソースが見つかりません'
            },
            '401': {
                message: '許可されていません',
                detailed_message:
                    'このページにアクセスするための十分な権限がないか、資格情報が無効のようです'
            },
            '400': {
                message: '無効なリクエスト',
                detailed_message:
                    'クライアントのエラーにより、サーバーがリクエストを処理できません'
            },
            '201': {
                message: '作成完了',
                detailed_message: 'リクエストは実行されました'
            },
            '0': {
                message: '何かしらの異常があります',
                detailed_message: '問題が発生しました'
            }
        },
        success: {
            all_recorders_removed: '選択したレコーダーが正常に削除されました',
            all_recorder_logs_removed:
                '選択したレコーダーのログが正常に削除されました',
            recorders_removed:
                '次のレコーダーが正常に削除されました：{{ list }}',
            recorders_status_changed:
                '状態の更新には約10秒かかります。変更を確認するには、リスト更新してください。'
        },
        expressions: {
            not_found: '見つかりませんでした',
            save_template: 'テンプレートを保存',
            template_saved: '"{{name}}"を保存しました',
            delete_recorders: 'レコーダーを削除',
            delete_recorder_logs: 'レコーダーログを削除',
            delete_offline_recorders: 'オフラインレコーダーを削除',
            delete_template: 'テンプレートを削除',
            delete_templates: 'テンプレートを削除',
            delete_template_success: '"{{name}}" は無事削除されました',
            delete_template_failed: '',
            template_name: 'テンプレート名',
            max_record_duration_min: '最長記録時間、分',
            record_on_assignment: '割当後記録開始',
            start_recording_when_assigned_to_recorder:
                'レコーダー割当後、記録開始',
            record_extended_element_data: '拡張アプリケーション情報を記録する',
            application_list: 'アプリケーションリスト',
            field_redaction: 'マスク処理',
            whitelist: 'ログ対象リスト',
            blacklist: 'ログ除外リスト',
            add_template: 'テンプレートの追加',
            add_template_success: '{{name}}が追加されました',
            delete_templates_success:
                '削除されたテンプレート： {{deletedTemplates}}',
            delete_templates_failed: '次のテンプレートの削除に失敗しました',
            delete_selected: '選択を削除',
            obfuscate_user_data: 'ユーザーデータを難読化',
            turn_off: 'オフ',
            turn_on: 'オン',
            set_template: 'テンプレート設定',
            set_tag: 'タグ設定',
            refresh_list: 'リスト更新',
            last_seen: '最終更新日時',
            events_parenthesis_thousands: 'イベント数（千）',
            log_id: 'ログID',
            recording_start: '記録開始',
            duration_parenthesis_minutes: '記録時間（分）',
            duration: '期間',
            disk_space_parenthesis_mb: 'ディスク容量（MB）',
            processing_percent: '処理中（%）',
            last_project: '直近のロード先',
            download: 'ダウンロード',
            load_to_project: 'プロジェクトにロード',
            recorded_events: 'イベント数',
            events: 'イベント',
            apps: 'アプリ',
            forms: 'フォーム',
            unique_events: '一意のイベント',
            disk_space: 'ディスク容量',
            add_item_to_whitelist: 'アイテムをログ対象リストに追加',
            add_item_to_blacklist: 'アイテムをログ除外リストに追加',
            add_item: 'アイテム追加',
            edit_item: 'アイテム編集',
            recorders_count: 'レコーダー数',
            missing_credentials: '資格情報がありません',
            missing_state_or_code: '状態またはコードパラメータがありません',
            select_template_for_recorders: 'レコーダーのテンプレートを選択',
            change_tag_of_recorders: 'レコーダーのタグを変更する',
            no_ongoing_or_completed_processes:
                '進行中または完了したプロセスはありません',
            delete_log_success: 'ログが削除されました{{id}}',
            delete_log_failed: 'ログ削除が失敗しました：{{id}}',
            delete_logs_success: 'ログが削除されました',
            delete_logs_failed: '次のログ削除が失敗しました',
            uploading_logs: 'ログをアップロード中',
            uploading_screenshots: 'スクリーンショットをアップロード中',
            transforming_logs_all: '選択したログを変換中',
            uploading_logs_success:
                '次のログがプロジェクト<0>"{{projectName}}"</0>に正常にインポートされました： {{logList}}',
            transformation_success:
                '以下のログの変換が完了しました： {{logList}}',
            transformation_success_all: '選択したログの変換が完了しました',
            uploading_logs_failed:
                'プロジェクト"{{projectName}}"へのログ{{logList}}のインポートに失敗しました',
            transformation_failed: 'ログ{{logList}}の変換に失敗しました',
            transformation_failed_all: '選択したログの変換に失敗しました',
            transformation_cancelled:
                '次のログの変換がキャンセルされました： {{logList}}',
            transformation_cancelled_all: '変換がキャンセルされました',
            uploading_logs_cancelled:
                '次のログのプロジェクトへのアップロードがキャンセルされました： {{logList}}',
            size_in_megabytes: 'メガバイト容量',
            logs_count: 'ログの数',
            project_list: 'プロジェクトリスト',
            select_project: 'プロジェクトの選択',
            create_project: 'プロジェクトの作成',
            no_desktop_enabled_project_text:
                'タスクマイニングに対応したプロジェクトが存在していません。ログのエクスポートは、タスクマイニングが有効なTimelineプロジェクトに対してのみ可能です。今すぐ（下のフィールドから）Task Miningプロジェクトを作成することができます。プロジェクトを作成することにより、選択したログをプロジェクトに自動的にエクスポートします。',
            sort_after_Ascending: '降順でソート',
            sort_after_Descending: 'ソートをキャンセル',
            sort_after_None: '昇順でソート',
            timeline_url: 'Timeline URL',
            app_url: 'Recording Service パブリックURL',
            app_url_info:
                'ユーザーはこのURLでRecording Serviceにアクセスするため、localhostよりもホスト名を使うことをお勧めします。',
            import_queued: 'インポートはキューに登録されました',
            importing_logs: 'ログをインポート中',
            importing_success: 'インポート成功',
            importing_failed: 'インポート失敗',
            uploading_logs_queued:
                '以下のログはプロジェクト"{{projectName}}"のアップロードキューに追加されました： {{logList}}',
            transformation_queued:
                '以下のログは変換モデルのキューに追加されました： {{logList}}',
            transformation_queued_all:
                'すべてのログは変換のためにキューに入れられました',
            obfuscation_queued: 'ログ{{id}}は難読化キューに追加されました',
            obfuscation_pre_processing: 'ログ{{id}}を難読化のために事前処理中',
            obfuscation_processing: 'ログ{{id}}の難読化が進行中',
            obfuscation_finished: 'ログ{{id}}は無事難読化されました',
            obfuscation_failed: 'ログ{{id}}の難読化に失敗しました',
            status_of_uploading_logs_updated:
                '進行中の作業についての進捗メッセージを受信しました',
            project_name: 'プロジェクト名',
            uploading_logs_process:
                'プロジェクト"{{projectName}}"へログ{{logList}}をインポート中',
            deletion_success: 'ログを削除しました： {{logList}}',
            deleting_logs: 'ログを削除しています： {{logList}}',
            deletion_cancelled:
                '次のログの削除がキャンセルされました： {{logList}}',
            deletion_queued:
                '次のログの削除がキューに追加されました： {{logList}}',
            everything_broken:
                '致命的なエラーが発生、管理者に連絡してください。',
            show_message: 'メッセージを表示',
            delete_logs: 'ログを削除',
            delete_log: 'ログを削除',
            cannot_be_empty: '空にできません',
            project_name_taken:
                'このプロジェクト名はすでに使われています。別の名前にしてください。',
            invalid_name_length:
                '名前を空白もしくは200字を超えて設定することはできません。',
            cannot_be_duplicate: 'このアイテムは既に存在しています',
            x_minutes: '{{minutes}}分',
            save_connection: '保存',
            reset_connection: 'リセット',
            name_of_connection: '接続の名前',
            client_id: 'クライアントID',
            client_secret: 'クライアントシークレット',
            oauth_nav_message: 'Timeline 認証にリダイレクトされます：',
            image_not_found: '画像が見つかりません',
            start_date: '開始日',
            end_date: '終了日',
            last_seven_days: '過去7日間',
            last_thirty_days: '過去30日間',
            this_month: '今月',
            last_month: '先月',
            reset_filter: 'リセット',
            timeline_connection: 'Timeline認証',
            log_upload_limit_message:
                '選択したログのデータは20GB以上あります。いくつかのスクリーンショットはアップロードされません。続行しますか？',
            timeline_connection_guide: {
                title: 'Timeline認証ガイド',
                content: {
                    line_1:
                        '<strong>TimelineURLは</strong>、インストールされている Timeline インスタンスのURLである必要があります。Timelineをインストールしていない場合は、今すぐインストールしてください。',
                    line_2: {
                        main:
                            '実行中のTimeline インスタンスでアカウントを作成し、ログインを実施、',
                        a:
                            'アカウント設定→OAuthへ移動し、「クライアントを登録」をクリックします',
                        b: {
                            main: 'クライアント登録フォームを入力します',
                            i: '<strong>アプリ名</strong>は何でも構いません',
                            ii: {
                                1: '<strong>アプリケーションURL</strong>',
                                2: 'アイコンをクリックしてこの値をコピーし、Timeline のクライアント登録フォームに貼り付けます'
                            },
                            iii: {
                                1: '<strong>リダイレクトURI</strong>',
                                2: 'アイコンをクリックしてこの値をコピーし、Timeline のクライアント登録フォームに貼り付けます'
                            },
                            iv:
                                'オプションでクライアントロゴをアップロードすることもできます',
                            v:
                                '必ず<code>機密のクライアント</code>チェックボックスにチェックを入れてください',
                            vi:
                                '<code>プロジェクトの読み込み</code>と<code>プロジェクトの書き込み</code>チェックボックスだけにチェックを入れてください',
                            vii: '「クライアントを登録」をクリックします'
                        },
                        c:
                            '<code>クライアントID</code>と<code>クライアントシークレット</code>の値をそれぞれこの画面にコピーします'
                    },
                    line_3: '「保存」をクリックしてください。'
                }
            },
            upload_error_ScreenshotSizeExceeded:
                'スクリーンショットのサイズが、選択したログの上限を超えました。いくつかのスクリーンショットはアップロードされません。',
            upload_error_UniqueEventNumberExceeded:
                '選択したログには、上限を超える一意のイベントが含まれています。アップロードを続行できません。',
            upload_error_EventNameLengthExceeded:
                '選択されたログには、上限を超えたイベント名の長さが含まれてます。アップロードを続行できません。',
            upload_error_NoLogsFound:
                'ログが見つかりません。アップロードを続行できません。',
            upload_error_UnsupportedLogVersion:
                'こちらのバージョンには対応していません。',
            confirm_navigation_title: 'ナビゲーションの確認',
            confirm_navigation_body_1: '保存されていない変更があります。',
            confirm_navigation_body_2:
                '「OK」をクリックすると、変更が失われます。',
            confirm_navigation_body_3: '続行しますか？',
            create_transformation: '変換モデルを追加',
            edit_transformation: '変換モデルを編集',
            not_valid_regex: '有効な正規表現ではありません。',
            apply_transformation: '変換モデルを適用',
            apply_to_all_logs: '全てのログに適用',
            apply_to_selected_logs: '選択したログに適用',
            delete_transformations: '変換モデルを削除',
            delete_transformation: '変換モデルを削除',
            add_transformation_success: '変換モデルが追加されました',
            edit_transformation_success: '変換モデルが編集されました',
            apply_transformations_success: '変換モデルは正常に適用されました',
            delete_transformations_success: '変換モデルは正常に削除されました',
            delete_transformations_failed:
                '変換モデル削除中にエラーが発生しました',
            must_be_number: '数字の必要があります。',
            about_modal_title: 'ABBYY Recording Serviceについて',
            base_url_copied: 'ベースURLがクリップボードにコピーされました',
            callback_url_copied:
                'リダイレクトURLがクリップボードにコピーされました',
            legal_text: 'ABBYY Development Inc',
            to_create_transformation:
                '変換モデルを作成または更新するには次へ移動してください：',
            this_page: 'こちらのページ',
            no_transformations:
                '変換モデルがありません。作成するには<0>こちらのページ</0>へ移動してください。',
            assign_transformation: 'テンプレートに変換モデルを追加',
            tag_change_success: 'タグが正常に変更されました',
            recorder_template_change_success:
                'テンプレートが正常に変更されました',
            outdated_recorder:
                'このレコーダーは、Recording Service バージョンと互換性がありません。更新する必要があります',
            language: '言語',
            server_settings: 'ログ',
            obfuscate_on_export: 'ユーザーデータを難読化',
            change_language: '言語を変更する',
            scheduled_recording: 'スケジュール管理',
            copy_instructions: 'クリップボードにコピー: Ctrl+C、Enter',
            merge_hosts: '複数のホストからデータを統合する',
            processing: '処理中: {{value}}%',
            processed: '処理済',
            total_values: '合計\n値',
            unique_values: '固有\n値',
            log_version_mismatch:
                '選択したログは互換性がなく、一緒にアップロードすることはできません',
            compatible_projects: 'ログ形式と互換性のあるプロジェクトのリスト',
            missing_forms: `まだ検出されたフォームはありません。記録セッションが進行中、もしくはフォームを検出中の可能性があり、まだ時間がかかる場合があります。しかし、Timelineにログをアップロードすることはできます。ログステータスが処理されていれば、処理されたログのフォームがここで計算されます。`,
            cant_upload_logs_without_screenshots:
                'スクリーンショットがなくてログをアップロードできない',
            cant_upload_old_log_version:
                'バージョン5.3以前でのログはTimelineにアップロードできなくなりました。',
            blocked_recording:
                'このアプリケーションではユーザーアクティビティの記録が許可されていないため、スクリーンショットがありません。',
            disclose_operator: '「ログ」タブにユーザー名を表示',
            export_operator: 'ユーザー名を含める',
            export_host: 'コンピューター名を含める',
            agent_id: 'エージェントID',
            no_form_found: 'フォームがありません'
        },
        delete_modal: {
            delete_item: 'このアイテムを完全に削除してもよろしいですか？',
            delete_recorder_logs:
                '選択したレコーダーのログを完全に削除してもよろしいですか？',
            delete_items: 'これらアイテムを完全に削除してもよろしいですか？',
            warning_recorder_online:
                'オンラインレコーダーを削除することはできません。オフラインのみ削除できます。再度削除する前に、それらを停止（オフラインに）してください。'
        },
        obfuscate_modal: {
            text1:
                'この操作では、ユーザー機密情報をぼかす（難読化）ために選択されたログを変更します。このアクションは元に戻すことができず、時間がかかる場合があります。',
            text2: 'ログを難読化してもよろしいですか？'
        },
        obfuscation_response: {
            CannotFindTemplate:
                'セッションのテンプレートが見つかりません。データベースが破損している可能性があります。',
            RedactionPolicyAlreadyEnabled: '難読化はすでに有効です。',
            SessionIsActive:
                'セッションはアクティブです。レコーダーを停止して、後でお試しください。',
            ProcessingInProgress:
                '前のプロセスが完了していません。後でお試しください。'
        },
        status: {
            online: 'オンライン',
            offline: 'オフライン',
            recording: '記録中',
            unhealthy: '不健全'
        },
        filter_options: {
            Online: 'オンライン',
            Offline: 'オフライン',
            Recording: '記録中',
            true: '有効',
            false: '無効'
        },
        oauth_error:
            'Timeline プロジェクトの読み込み中にエラーが発生しました。システム管理者へ連絡してください。エラーコード： "{{errorCode}}"',
        invalid_clint_secret:
            'Recording ServiceがTimelineで認証されなかったため、Timeline接続が終了しました。Timelineの認証設定を確認し、再度接続してください。問題が続く場合は、ネットワーク管理者へ連絡してください。',
        languages: {
            'en-US': '英語',
            'ja-JP': '日本語'
        },
        project_roles: {
            DASHBOARD_VIEWER: 'ダッシュボード閲覧者',
            VIEWER: '閲覧者',
            USER: 'ユーザー',
            DATA_MASTER: 'データ管理者',
            ADMIN: '管理者',
            OWNER: 'オーナー'
        }
    }
};

export default translations;
